export default __webpack_public_path__ + "static/media/DonAgisha.46619389.jpg";